const listaDeSubModulos = (state) => {
    return state.items;
}

const loadingSubModulo = (state) => {
    return state.carregando
}

export {
    listaDeSubModulos,
    loadingSubModulo
}